import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

const HomepageVideo = ({ videoId }) => {
  const playerRef = useRef(null);

  useEffect(() => {
    const script = document.createElement('script');
    script.setAttribute('nonce', 'm7yvr64n3ob2ci9xdpl');
    script.src = 'https://www.youtube.com/iframe_api';
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      window.YT.ready(() => {
        new window.YT.Player(playerRef.current, {
          videoId,
        });
      });
    };

    return () => {
      document.body.removeChild(script);
    };
  }, [videoId]);

  return (
    <div className="homepage-video-container">
      <div className="homepage-video" ref={playerRef} />
    </div>
  );
};

export default HomepageVideo;

HomepageVideo.propTypes = {
  videoId: PropTypes.string.isRequired,
};
